module.exports = __webpack_public_path__ + "static/img/index1(1)_08.36047cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index1(1)_08.png
// module id = 3117
// module chunks = 1